// removed by extract-text-webpack-plugin
module.exports = {"ScrollUpButton__Container":"ScrollUpButton__Container___32SwK","ScrollUpButton__Toggled":"ScrollUpButton__Toggled___E4oTw","arrowWrapper":"arrowWrapper___2negf","arrowUp":"arrowUp___3tFoN","backToTopText":"backToTopText___2-vz6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BacktoTop/BackToTop.scss
// module id = Ah1N
// module chunks = 60